'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$66() {
  this.aId = null;
  this.aIb = null;
  this.aIc = false;
  this.aI9 = null;
  this.aIa = false;
  this.aIe = false;
  this.aIf = false;
  this.aId = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$66 as $c_Lpresto_CredentialsView$$anon$66 };
$p = $c_Lpresto_CredentialsView$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$66;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$66() {
}
export { $h_Lpresto_CredentialsView$$anon$66 as $h_Lpresto_CredentialsView$$anon$66 };
$h_Lpresto_CredentialsView$$anon$66.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aId;
});
$p.t = (function() {
  if ((!this.aIc)) {
    this.aIb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aIc = true;
  }
  return this.aIb;
});
$p.ag = (function() {
  if ((!this.aIa)) {
    this.aI9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().ae5()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aIa = true;
  }
  return this.aI9;
});
$p.v = (function() {
  if ((!this.aIf)) {
    this.aIe = false;
    this.aIf = true;
  }
  return this.aIe;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$66, "presto.CredentialsView$$anon$66", ({
  Gf: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$66 as $d_Lpresto_CredentialsView$$anon$66 };
//# sourceMappingURL=presto.-Credentials-View$$anon$66.js.map
